'use client'

import { type ReactNode } from 'react'

import { useBreakpoints } from '@src/utils/breakpoints.util'
import { cn } from '@src/utils/tailwind'

import { Checklist } from '../Checklist/Checklist'

export interface SplitContentCardProps {
  attributes?: any
  children?: ReactNode
  photoUrl: string
  photoHeight?: number
  mobilePhotoHeight?: SplitContentCardProps['photoHeight']
  titleText: string
  checkList: Array<{ text: string }>
}

export function SplitContentCard(props: SplitContentCardProps) {
  const { isMobile, isTablet } = useBreakpoints()

  function getProp<T>(prop: T, mobileProp: T) {
    return isMobile || isTablet ? mobileProp || prop : prop
  }

  const photoUrl = props.photoUrl
  const photoHeight = getProp(props.photoHeight, props.mobilePhotoHeight) ?? 300

  return (
    <div
      data-testid={props?.attributes?.['data-testid']}
      builder-id={props?.attributes?.['builder-id']}
      className={cn('flex flex-col rounded-[33px]', props?.attributes?.className)}
    >
      <section
        style={{
          backgroundImage: photoUrl ? `url('${photoUrl}?format=webp')` : undefined,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: photoHeight ?? 'auto',
        }}
        className="rounded-t-[33px] bg-cover bg-center bg-no-repeat px-6 lg:h-full lg:rounded-none lg:rounded-t-[33px] lg:px-16"
      >
        <div style={{ height: `${photoHeight}px` }} />
      </section>
      <section className="flex flex-col items-center justify-around rounded-b-[33px] border-x border-b border-solid border-neutral-200 lg:flex-row lg:rounded-b-[33px]">
        <div className="text-heading-display-2 flex size-full items-center px-6 py-4 pt-12 lg:w-2/3 lg:px-12 lg:py-4">
          <span>{props.titleText}</span>
        </div>
        <div className="flex w-full flex-col gap-4 px-6 py-8 lg:w-1/3 lg:py-10">
          <Checklist
            iconType="outline"
            iconSize={30}
            checkIcon="CheckCircleIcon"
            checkColor="#208468"
            textStyle="Body XL - Medium weight"
            separation={20}
            items={props.checkList?.map((item) => ({ value: item.text }))}
          />
        </div>
      </section>
    </div>
  )
}
